<template>
  <div>
    <Nav></Nav>
    <b-container fluid>

      <b-row>
        <b-col>
          <h1> Búsqueda de cuentas</h1>
        </b-col>
      </b-row>
      <ReportSearchBar :emitOnStart="false" :emitOnChange="false" @search="recvDoc"></ReportSearchBar>
      <b-card border-variant="primary" class="my-1">
        <b-overlay :show="loadingTicketsList" rounded="sm">
          <b-row class="my-3">
            <b-col>
              <p>Hay {{ tickets.length }} cuentas</p>
            </b-col>
          </b-row>
          <b-row v-if="tickets.length > 0">
            <b-col>
              <b-input-group prepend="Buscar:">
                <b-form-input debounce="500" v-model="filterTable"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row  v-if="tickets.length > 0">
            <b-col>
              <b-table :filter="filterTable" :per-page="byPage" :current-page="page" :busy="activeTicketsLoading" ref="tableCuentas" id="tableCuentas"
                selectable :responsive="true" select-mode="single" :items="tickets" :fields="activeTicketsFields"
                @row-clicked="getActiveTicket" small sticky-header="70vh" selected-variant="primary">
                <template #cell(shift_id)="data">
                  {{ data.item.shift_id }} <b-badge v-show="data.item.shift_id==null" variant="danger">Sin turno</b-badge>
                </template>
                <template #cell(waiter_complete.name)="data">
                  {{ data.item.waiter_complete.name.substring(0, 10) }}
                </template>
                <template #cell(cenceled)="data">
                  <b-icon class="ml-1" :icon="data.item.canceled?'dash-circle-fill':'check-circle-fill'" :variant="data.item.canceled?'danger':'success'"></b-icon>
                  <b-icon class="ml-1" :icon="data.item.printed?'printer-fill':'printer'" :variant="data.item.printed?'success':'primary'"></b-icon>
                  <b-icon class="ml-1" :icon="data.item.paid?'cash-stack':'cash-stack'" :variant="data.item.paid?'success':'primary'"></b-icon>
                </template>
                <template #cell(total_with_discount)="data">
                  $ {{ data.item.total_with_discount }}
                </template>
                <template #cell(factura)="data">
                  <!-- "Cargando" y "Sin factura" son estados distintos: mientras
                       el lote de status no vuelve, un guion se lee como "no se
                       facturo", que es justo lo contrario de lo que se sabe. -->
                  <b-spinner v-if="statusFactura(data.item.sid) === null" small variant="secondary"
                    label="Consultando facturacion"></b-spinner>
                  <div v-else-if="statusFactura(data.item.sid).invoiced">
                    <b-badge :variant="variantFactura(statusFactura(data.item.sid))">
                      {{ etiquetaFactura(statusFactura(data.item.sid)) }}
                    </b-badge>
                    <div class="small text-monospace" :title="tituloFactura(statusFactura(data.item.sid))">
                      {{ statusFactura(data.item.sid).folio || statusFactura(data.item.sid).provider_invoice_id }}
                    </div>
                  </div>
                  <b-badge v-else variant="secondary">Sin factura</b-badge>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination v-model="page" :total-rows="tickets.length" :per-page="byPage"
                aria-controls="my-table"></b-pagination>
            </b-col>
          </b-row>
        </b-overlay>
      </b-card>

    </b-container>
    <CuentaDetalle @changeTicketId="closeAccount()" @invoiced="refrescarStatusFactura"
      :ticket_id="activeTicketId"></CuentaDetalle>
  </div>
</template>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import CuentaDetalle from "../components/CuentaDetalle.vue";
import ReportSearchBar from "./reports/searchBar/ReportSearchBar.vue";
import moment from 'moment'
export default {
  name: "CuentasHistoricas",
  components: {
    Nav, CuentaDetalle, ReportSearchBar
  },

  data() {
    return {
      byPage: 30,
      page: 1,
      filterTable: "",
      sucursalOptions: [],
      queryDatesTickets: {
        initial_date: "",
        end_date: "",
        sucursal_id: [],
      },
      helpKeys: false,
      log: [],
      logFields: [
        { key: "action_id", label: "ID" },
        { key: "action_date", label: "Fecha" },
        { key: "description", label: "Descripcion" },
      ],
      loadingCuenta: false,
      loadingTicketsList: false,
      activeTicketsLoading: false,
      lastInput: "",
      tickets: [],
      paymentFields: [
        { key: "id", label: "ID" },
        { key: "payment_method.name", label: "Metodo de pago" },
        { key: "payment_amount", label: "Monto" },
        { key: "tip_amount", label: "Propina" },
        { key: "status", label: "Status" },
        { key: "buttons", label: "" }
      ],
      activeTicketsFields: [
        { key: "numticket", label: "Folio", sortable: true },
        { key: "shift_id", label: "Turno", sortable: true },
        { key: "restaurant_area.name", label: "Area", sortable: true },
        { key: "waiter_complete.name", label: "Mesero", sortable: true },
        { key: "table_no", label: "Mesa", sortable: true },
        { key: "cenceled", label: "Canc.", sortable: true },
        { key: "total_with_discount", label: "Tot.", sortable: true },
        { key: "date_open", label: "Fecha Apertura", sortable: true },
        { key: "sucursal.nombre", label: "Sucursal", sortable: true },
        { key: "factura", label: "Factura", sortable: false },
      ],
      actualCuentaFields: [
        { key: "movement", label: "Mov" },
        { key: "quantity", label: "Cant" },
        { key: "product_code", label: "Clave" },
        { key: "cancelled", label: "Canc." },
        { key: "product.ndescription", label: "Descripcion" },
        { key: "discount_percentage", label: "Descuento" },
        { key: "price", label: "Precio" },
        { key: "total_with_discount", label: "Total" },
      ],
      actualCuenta: {
        ticket_products: [],
        restaurant_area: {
          name: "",
        },
        discount_type: {
          name: "",
        },
      },
      activeTicketId: 0,
      // sid del ticket -> status de facturacion devuelto por el backend
      invoiceStatus: {},
    };
  },
  computed: {
  },
  watch: {},
  mounted() {
    this.querySucursals()
  },
  created() {

  },
  methods: {
    recvDoc(p) {
      this.queryDatesTickets.initial_date = moment(p.initDate).format("YYYY-MM-DD")
      this.queryDatesTickets.end_date = moment(p.endDate).format("YYYY-MM-DD")
      this.queryDatesTickets.sucursal_id = p.sucursales
      this.getTicketsByDate()
    },
    querySucursals() {
      let that = this
      axios
        .get("/sucursals")
        .then(function (response) {
          let finalSucs = []
          response.data.forEach(element => {
            finalSucs.push({ value: element.id, text: element.id + " - " + element.nombre, nm: element.nombre })
          })
          finalSucs = finalSucs.sort(function (a, b) {
            return a.nm.localeCompare(b.nm);
          });
          that.sucursalOptions = finalSucs
        })
        .catch(function (r) {
          console.log(r)
          that.makeToast("danger", "Error", r.response.data);
        });
    },
    getTicketsByDate() {
      if (
        this.queryDatesTickets.initial_date.length < 1 ||
        this.queryDatesTickets.end_date.length < 1
      ) {
        this.loadingTicketsList = false;
        this.makeToast(
          "danger",
          "FECHAS INCORRECTAS",
          "DEBES SELECCIONAR FECHAS CORRECTAS"
        );
        return;
      }
      this.loadingTicketsList = true;
      let that = this;
      axios
        .post("/tickets/date", this.queryDatesTickets)
        .then(function (response) {
          if (response.data != null) {
            that.tickets = response.data;
          }
          that.page=1
          that.loadingTicketsList = false;
          that.cargarStatusFacturas()
        })
        .catch(function (r) {
          that.loadingTicketsList = false;
          that.makeToast("danger", "Error", r.response.data);
          that.loadingTicketsList = false;
        });
    },
    statusFactura(sid) {
      return Object.prototype.hasOwnProperty.call(this.invoiceStatus, sid)
        ? this.invoiceStatus[sid]
        : null;
    },
    // El backend acota cada llamada a 500 tickets, asi que un rango largo se
    // parte en tandas en vez de pedir el status uno por uno.
    //
    // Las tandas se pintan conforme llegan y corren de a pocas: un rango de una
    // semana con todas las sucursales son ~20 tandas, y dispararlas juntas
    // esperando a que terminen TODAS dejaba la columna en blanco varios
    // segundos, que es lo que se lee como "la columna no funciona".
    cargarStatusFacturas() {
      this.invoiceStatus = {};
      let sids = this.tickets.map((t) => t.sid).filter((sid) => sid > 0);
      if (sids.length === 0) return;
      let tandas = [];
      for (let i = 0; i < sids.length; i += 500) {
        tandas.push(sids.slice(i, i + 500));
      }
      this.correrTandas(tandas, 4);
    },
    // Corre las tandas con como maximo `concurrencia` en vuelo, pintando cada
    // una en cuanto responde.
    correrTandas(tandas, concurrencia) {
      let that = this;
      let siguiente = 0;
      let trabajador = function () {
        if (siguiente >= tandas.length) return Promise.resolve();
        let tanda = tandas[siguiente++];
        return that.pedirStatusFacturas(tanda).then(function (lista) {
          that.pintarStatus(lista);
          return trabajador();
        });
      };
      let trabajadores = [];
      for (let i = 0; i < Math.min(concurrencia, tandas.length); i++) {
        trabajadores.push(trabajador());
      }
      return Promise.all(trabajadores);
    },
    pintarStatus(lista) {
      if (lista.length === 0) return;
      let parcial = {};
      lista.forEach(function (status) {
        parcial[status.ticket_sid] = status;
      });
      // Reemplazo del objeto completo para que la tabla reaccione en Vue 2.
      this.invoiceStatus = Object.assign({}, this.invoiceStatus, parcial);
    },
    // El status que importa es el de la autoridad fiscal: una factura creada en
    // el proveedor pero sin aceptar por la DIAN no esta realmente timbrada.
    variantFactura(status) {
      let autoridad = (status.status || "").toUpperCase();
      if (autoridad === "REJECTED" || autoridad === "RECHAZADA") return "danger";
      if (autoridad === "ACCEPTED" || autoridad === "" || autoridad === "VALID") return "success";
      return "warning";
    },
    etiquetaFactura(status) {
      let autoridad = (status.status || "").toUpperCase();
      if (autoridad === "REJECTED" || autoridad === "RECHAZADA") return "Rechazada";
      if (autoridad === "PENDING" || autoridad === "PENDIENTE") return "Pendiente";
      return "Facturada";
    },
    // El CUFE/UUID no cabe en la celda pero es lo que se cruza contra la DIAN,
    // asi que va en el tooltip junto al resto de la identificacion.
    tituloFactura(status) {
      let partes = [];
      if (status.folio) partes.push("Folio " + status.folio);
      if (status.cufe) partes.push("CUFE " + status.cufe);
      else if (status.uuid) partes.push("UUID " + status.uuid);
      if (status.provider_invoice_id) partes.push("ID proveedor " + status.provider_invoice_id);
      if (status.razon_social_receptor) partes.push(status.razon_social_receptor);
      if (status.fecha_timbrado) partes.push(status.fecha_timbrado);
      return partes.join("\n");
    },
    pedirStatusFacturas(sids) {
      return axios
        .post("/compliance/tickets/invoice-status", { ticket_sids: sids })
        .then(function (response) {
          return response.data || [];
        })
        .catch(function () {
          // Sin status la columna queda en guion; no vale tumbar el listado.
          return [];
        });
    },
    refrescarStatusFactura(sid) {
      let that = this;
      this.pedirStatusFacturas([sid]).then(function (lista) {
        if (lista.length === 0) return;
        that.invoiceStatus = Object.assign({}, that.invoiceStatus, { [sid]: lista[0] });
      });
    },
    closeAccount() {
      this.activeTicketId = 0;
      this.$refs.tableCuentas.clearSelected();
      console.log("closeAccount event emitted")
    },
    getActiveTicket: function (row) {
      this.activeTicketId = row.sid;
    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvToast.toast(text, {
        title: title,
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
  },
};
</script>
